import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import MerchantCustomer from './MerchantCustomer';
import MerchantOperationCost from './MerchantOperationCost';
import MerchantSubscriptionFee from './MerchantSubscriptionFee';
import MerchantSalesReport from './MerchantSalesReport';
import { renderTypeString } from 'utils';

const InvoicesMerchantDetail = () => {
  const location = useLocation<{
    id: number;
    type: ReturnType<typeof renderTypeString>;
    invoicesNumber: string;
  }>();
  const { type, id } = location.state;

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'auto' });
  }, []);

  if (type === `Commerçant pour le client`) {
    return <MerchantCustomer onId={id} />;
  }
  if (type === `Frais de service Achil`) {
    return <MerchantOperationCost onId={id} />;
  }
  if (type === `Facture d'abonnement Achil`) {
    return <MerchantSubscriptionFee onId={id} />;
  }
  if (type === `Abonnement Achil`) {
    return <MerchantSalesReport onId={id} />;
  }

  return <div>Opps! Page is not found</div>;
};

export default InvoicesMerchantDetail;
